import { getUserId } from "store/currentUser/currentUserSelector";
import { useSelector } from "react-redux";

export default function useCurrentUserId(): number | null {
  return useSelector(getUserId);
}
